<template>
  <div id="export-records">
    <div class="export-records-table">
      <div class="export-records-table-card">
        <div class="export-records-table-card-content">
          <el-table
              :data="tableData"
              highlight-current-row
              style="width:850px;"
              height="420px"
              v-loading="loading"
          >
            <el-table-column prop="sort" label="序号" width="70" fixed> </el-table-column>
            <el-table-column prop="filePath" label="文件名" width="400" fixed></el-table-column>
            <el-table-column prop="createUsername" label="创建人" width="100" fixed></el-table-column>
            <el-table-column prop="gmtCreate" label="创建时间" width="190" fixed></el-table-column>
            <el-table-column label="操作" width="90" fixed>
              <template slot-scope="scope">
                <span style="color: #409eff; cursor: pointer;" @click="handleDownload(scope.row)">下载</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="human-payroll-table-card-bottom">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="pageData.currentPage"
              :page-size="pageData.pageSize"
              :page-sizes="pageData.pageSizes"
              layout="total,sizes, prev, pager, next,jumper"
              :total="pageData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["exprotResourcesData"],
  data() {
    return {
      value: this.exprotResourcesData,
      loading: false,
      baseInfo: {},
      tableData: [],
      allFunctionButtons: this.$featureData.getAllFunctionButtons(
          "dispatchEvidence",
      ),
      pageData: {
        // 分页参数
        currentPage: 1, // 当前页数
        total: 0, // 总条目数
        pageSize: 5, // 每页条数
        pageSizes: [5, 10, 20],
      },
    };
  },
  methods: {
    /**
     * 页码选择器改变事件
     * val:每页条数
     */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageData.pageSize = val;
      this.initTableData();
    },
    /**
     * 选择页码事件
     * val:当前页
     */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.initTableData();
    },
    resetPage() {
      this.pageData.currentPage = 1;
      this.initTableData();
    },
    /**
     * 初始化表格数据
     */
    initTableData() {
      this.tableData = [];
      this.loading = true;
      let requestData = {
        clientId: this.value.clientId,
        currentPage: this.pageData.currentPage, // 当前页数
        pageSize: this.pageData.pageSize, // 每页条数
      };
      this.$request(
          "post",
          "/export-ppt-records/page",
          requestData,
          (data) => {
            this.tableData = data.records;
            this.pageData.total = data.total; // 获取总条目数
            this.loading = false;
          },
          (errorMessage) => {
            this.$message.error(errorMessage);
            this.loading = false;
          },
      );
    },
    handleDownload(data) {
      let recordId = data.id
      const url = this.$baseurl + '/export-ppt-records/downloadppt?recordId=' + recordId
      window.open(url, '_blank')
    },
  },
  created() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.initTableData();
  },
};
</script>

<style lang="less" scoped>
#export-records {

}
</style>
